import { render, staticRenderFns } from "./ProductDetailsPageTemplate.vue?vue&type=template&id=afbf1468&scoped=true&"
import script from "./ProductDetailsPageTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsPageTemplate.vue?vue&type=style&index=0&id=afbf1468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbf1468",
  null
  
)

export default component.exports